export const weekdayStrings = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
export const dayStrings = weekdayStrings.concat(['SATURDAY', 'SUNDAY']);
